module.exports = __webpack_public_path__ + "static/media/pixel-art.66d427e7.mp4";